import React, { FC, Fragment } from 'react';
import classNames from 'classnames';

import { IHelpCenterCategory } from '@sv-support-sdk/shared-types/src/common/helpCenter'
import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';

import CategoryBlockList from './../CategoryBlockList';
import { useAppSelector } from '../../../../store/hooks';
import { categoriesByGrandSelector } from '../../../../store/selectors/helpCenter';
import useMobileDetect from '../../../../hooks/useMobileDetect';

import css from './style.module.scss';

interface IProps {
  grandCategory: IHelpCenterCategory;
}

const CategoryBlock: FC<IProps> = ({ grandCategory }) => {
  const isMobile = useMobileDetect();

  const subCategories = useAppSelector((state) =>
    categoriesByGrandSelector(state, grandCategory.id),
  );

  return (
    <div className={css.categoryBlock}>
      <CategoryBlockList category={grandCategory} noTopicsAsCategories className="indent-3xl-top" />
      {subCategories &&
        subCategories.map((subCategory) => (
          <Fragment key={subCategory.id}>
            <Headline
              type="secondary"
              fontSize="20"
              lineHeight="32"
              className={classNames("indent-md-bottom", {
                [isMobile ? "indent-xxl-top" : "indent-56-top"]: true
              })}
            >
              {subCategory.name}
            </Headline>
            <CategoryBlockList category={subCategory} />
          </Fragment>
        ))}
    </div>
  );
};

export default CategoryBlock;
